/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface NetSuiteTransaction
 */
export interface NetSuiteTransaction {
  /**
   *
   * @type {string}
   * @memberof NetSuiteTransaction
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteTransaction
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteTransaction
   */
  tranId?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteTransaction
   */
  orderStatus?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteTransaction
   */
  tranDate?: string | null;
  /**
   *
   * @type {number}
   * @memberof NetSuiteTransaction
   */
  shippingCost?: number | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteTransaction
   */
  linkedShipment?: string | null;
}

/**
 * Check if a given object implements the NetSuiteTransaction interface.
 */
export function instanceOfNetSuiteTransaction(
  value: object,
): value is NetSuiteTransaction {
  return true;
}

export function NetSuiteTransactionFromJSON(json: any): NetSuiteTransaction {
  return NetSuiteTransactionFromJSONTyped(json, false);
}

export function NetSuiteTransactionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NetSuiteTransaction {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    type: json["type"] == null ? undefined : json["type"],
    tranId: json["tranId"] == null ? undefined : json["tranId"],
    orderStatus: json["orderStatus"] == null ? undefined : json["orderStatus"],
    tranDate: json["tranDate"] == null ? undefined : json["tranDate"],
    shippingCost:
      json["shippingCost"] == null ? undefined : json["shippingCost"],
    linkedShipment:
      json["linkedShipment"] == null ? undefined : json["linkedShipment"],
  };
}

export function NetSuiteTransactionToJSON(json: any): NetSuiteTransaction {
  return NetSuiteTransactionToJSONTyped(json, false);
}

export function NetSuiteTransactionToJSONTyped(
  value?: NetSuiteTransaction | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    type: value["type"],
    tranId: value["tranId"],
    orderStatus: value["orderStatus"],
    tranDate: value["tranDate"],
    shippingCost: value["shippingCost"],
    linkedShipment: value["linkedShipment"],
  };
}
